
		import React from 'react';

		function UserIcon() {
			return (
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0, 0 448, 512">
					<path d="M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM224 16c61.76 0 112 50.24 112 112c0 61.76-50.24 112-112 112S112 189.8 112 128C112 66.24 162.2 16 224 16zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304zM413.3 496H34.67C24.37 496 16 487.6 16 477.3C16 390.6 86.58 320 173.3 320h101.3C361.4 320 432 390.6 432 477.3C432 487.6 423.6 496 413.3 496z" />
				</svg>
			);
		}

		export default UserIcon;
	